module.exports = __webpack_public_path__ + "static/media/device_privatization_en.5bb6ba6e.md";